var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "search-table" },
        [
          _c("el-date-picker", {
            staticClass: "custom-date-picker",
            staticStyle: { width: "115px" },
            attrs: {
              clearable: false,
              type: "month",
              placeholder: "Chọn tháng",
              "value-format": "M-yyyy",
              format: "MM-yyyy",
              "time-arrow-control": false,
            },
            on: { change: _vm.handelUpdateDate },
            model: {
              value: _vm.monthAndYear,
              callback: function ($$v) {
                _vm.monthAndYear = $$v
              },
              expression: "monthAndYear",
            },
          }),
          _c(
            "el-select",
            {
              staticStyle: { width: "120px" },
              attrs: { placeholder: "Trạng thái" },
              on: { change: _vm.handleChangeKidStatus },
              model: {
                value: _vm.dataSearch.kidStatus,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "kidStatus", $$v)
                },
                expression: "dataSearch.kidStatus",
              },
            },
            _vm._l(_vm.kidStatusListExcel, function (item, index) {
              return _c("el-option", {
                key: index,
                attrs: { value: item.key, label: item.value },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticClass: "input-grade",
              staticStyle: { width: "160px" },
              attrs: { placeholder: "Chọn khối" },
              on: { change: _vm.handleChangeKidGrade },
              model: {
                value: _vm.dataSearch.idGrade,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "idGrade", $$v)
                },
                expression: "dataSearch.idGrade",
              },
            },
            _vm._l(_vm.gradeList, function (item, index) {
              return _c("el-option", {
                key: index,
                attrs: { value: item.id, label: item.gradeName },
              })
            }),
            1
          ),
          _c(
            "el-select",
            {
              staticStyle: { width: "160px" },
              attrs: { placeholder: "Chọn lớp" },
              on: { change: _vm.handleChangeKidClass },
              model: {
                value: _vm.dataSearch.idClass,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "idClass", $$v)
                },
                expression: "dataSearch.idClass",
              },
            },
            _vm._l(_vm.classList, function (item) {
              return _c("el-option", {
                key: item.id,
                attrs: { value: item.id, label: item.className },
              })
            }),
            1
          ),
          _c("el-input", {
            staticStyle: { width: "240px" },
            attrs: { clearable: "", placeholder: "Nhập tên, biệt danh" },
            on: { clear: _vm.handleClearKidName },
            nativeOn: {
              keyup: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.handleChangeKidName.apply(null, arguments)
              },
            },
            scopedSlots: _vm._u([
              {
                key: "append",
                fn: function () {
                  return [
                    _c("el-button", {
                      attrs: { icon: "el-icon-search" },
                      on: { click: _vm.handleSearchResultByName },
                    }),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.kidName,
              callback: function ($$v) {
                _vm.kidName = $$v
              },
              expression: "kidName",
            },
          }),
          _c(
            "el-select",
            {
              staticStyle: { width: "100px" },
              attrs: { placeholder: "Đợt thu" },
              on: { change: _vm.handleChangeCollectionTurn },
              model: {
                value: _vm.dataSearch.collectionTurn,
                callback: function ($$v) {
                  _vm.$set(_vm.dataSearch, "collectionTurn", $$v)
                },
                expression: "dataSearch.collectionTurn",
              },
            },
            _vm._l(_vm.collectionTurn, function (item) {
              return _c("el-option", {
                key: item,
                attrs: { value: item, label: `Đợt ${item}` },
              })
            }),
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        [
          _c(
            "el-table",
            {
              attrs: {
                "element-loading-spinner": "el-icon-loading",
                "empty-text": _vm.textTable,
                data: _vm.responseFilterList,
                "element-loading-text": _vm.$tableLoading,
                "element-loading-background": "rgba(255,255,255, 0)",
                "header-cell-style": _vm.tableHeaderColor,
                "max-height": _vm.$tableMaxHeight,
                "summary-method": _vm.getSummaries,
                "show-summary": "",
                border: "",
              },
              on: { "selection-change": _vm.handleSelectionChange },
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  fixed: "left",
                  label: "STT",
                  width: "50",
                  align: "center",
                },
              }),
              _c("el-table-column", {
                attrs: { width: "150", fixed: "left", label: "Họ tên" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-tooltip", { attrs: { placement: "top" } }, [
                          _c(
                            "div",
                            { attrs: { slot: "content" }, slot: "content" },
                            [
                              _vm._v(
                                "Mã học sinh: " + _vm._s(scope.row.kidCode)
                              ),
                              _c("br"),
                              _vm._v(
                                "Bố/Mẹ: " +
                                  _vm._s(scope.row.fatherPhone) +
                                  " -\n              " +
                                  _vm._s(scope.row.motherPhone) +
                                  "\n            "
                              ),
                            ]
                          ),
                          _c("span", [_vm._v(_vm._s(scope.row.fullName))]),
                        ]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { width: "90", label: "Biệt danh", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.nickName))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", width: "110", label: "Trạng thái" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { class: _vm.getStatusColor(scope.row.status) },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.getStatusValue(scope.row.status)) +
                                "\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  "min-width": "120",
                  label: "Thiếu/Thừa tháng trước",
                  prop: "beforeMoney",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatCurrency")(scope.row.beforeMoney)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  "min-width": "120",
                  label: "Phải thu tháng này",
                  prop: "sumMoney",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatCurrency")(scope.row.sumMoney)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  "min-width": "120",
                  label: "Đã thu",
                  prop: "collectedMoney",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm.getStatusValue(scope.row.status) !==
                        "Chưa có hóa đơn"
                          ? _c(
                              "el-button",
                              {
                                staticClass: "click-in-row",
                                attrs: { type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.collectedMoneyMethod(scope.row)
                                  },
                                },
                              },
                              [
                                scope.row.collectedMoney
                                  ? _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          _vm._f("formatCurrency")(
                                            scope.row.collectedMoney
                                          )
                                        )
                                      ),
                                    ])
                                  : _c("span", [_c("b", [_vm._v("-")])]),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  "min-width": "120",
                  label: "Tiền mặt",
                  prop: "cashMoney",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatCurrency")(scope.row.cashMoney)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  "min-width": "120",
                  label: "Chuyển khoản",
                  prop: "transferMoney",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatCurrency")(scope.row.transferMoney)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  "min-width": "120",
                  label: "Thiếu / Thừa còn lại",
                  prop: "afterMoney",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm._f("formatCurrency")(scope.row.afterMoney)
                            ) +
                            "\n        "
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._l(_vm.feeItems, function (item, index) {
                return _c("el-table-column", {
                  key: index,
                  attrs: {
                    align: "right",
                    width: "115",
                    label: item.label,
                    prop: item.prop,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "header",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tooltip",
                              {
                                attrs: {
                                  content: scope.column.label,
                                  placement: "top",
                                },
                              },
                              [_c("span", [_vm._v(_vm._s(scope.column.label))])]
                            ),
                          ]
                        },
                      },
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm.getStatusValue(scope.row.status) !==
                            "Chưa có hóa đơn"
                              ? _c(
                                  "el-button",
                                  {
                                    staticClass: "click-in-row",
                                    attrs: { type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getDetailKT(
                                          scope.row,
                                          scope.column.label,
                                          scope.row.status
                                        )
                                      },
                                    },
                                  },
                                  [
                                    scope.row[item.prop]
                                      ? _c("span", [
                                          _vm._v(
                                            "\n      " +
                                              _vm._s(
                                                _vm._f("formatCurrency")(
                                                  scope.row[item.prop]
                                                )
                                              ) +
                                              "\n    "
                                          ),
                                        ])
                                      : _c("span", [_vm._v("-")]),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ],
                    null,
                    true
                  ),
                })
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "el-row",
        { staticStyle: { "margin-top": "15px" } },
        [
          _c(
            "el-col",
            {
              staticStyle: {
                display: "inline-flex",
                "justify-content": "right",
              },
              attrs: { span: 22 },
            },
            [
              _c("el-pagination", {
                staticStyle: {
                  "margin-right": "35.2rem",
                  "margin-left": "auto",
                },
                attrs: {
                  "current-page": _vm.currentPagePagination,
                  "page-sizes": _vm.listSizeLimit,
                  "page-size": _vm.sizeLimit,
                  layout: " prev, pager,sizes, next",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                  "update:currentPage": function ($event) {
                    _vm.currentPagePagination = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.currentPagePagination = $event
                  },
                },
              }),
            ],
            1
          ),
          _c("el-col", { attrs: { span: 2 } }, [
            _c(
              "div",
              { staticStyle: { float: "right", margin: "15px 0" } },
              [
                _c(
                  "el-dropdown",
                  { on: { command: _vm.handleCommand } },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "button-bottom",
                        attrs: { type: "success" },
                      },
                      [
                        _vm._v("\n            Tác vụ\n            "),
                        _c("i", { staticClass: "el-icon-caret-bottom" }),
                      ]
                    ),
                    _c(
                      "el-dropdown-menu",
                      { staticClass: "el-dropdown-menu-container" },
                      [
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "initializeData" } },
                          [_vm._v("Khởi tạo đợt thu")]
                        ),
                        _c(
                          "el-dropdown-item",
                          { attrs: { command: "initializeOrderKidsExcel" } },
                          [_vm._v("Khởi tạo hóa đơn")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c(
        "div",
        [
          _c("ImportDataRevenueDialog", {
            attrs: {
              isOpenImportData: _vm.isOpenImportData,
              listIdRevenueManagement: _vm.listIdRevenueManagement,
              listIdKids: _vm.listIdKids,
              dataSearch: _vm.dataSearch,
              type: _vm.type,
            },
            on: { close: _vm.closeImportDataRevenueDialog },
          }),
          _c("DetailKTRevenueDialog", {
            ref: "DetailKTRevenueDialog",
            attrs: {
              type: _vm.type,
              idOrder: _vm.idOrder,
              isOpenDetailKT: _vm.detailKT,
            },
            on: { close: _vm.closeDetailKTRevenueDialog },
          }),
          _c("CollectedMoneyRevenueDialog", {
            ref: "CollectedMoneyRevenueDialog",
            attrs: { isOpenCollectedMoney: _vm.showCollectedMoney },
            on: { closeCollectedMoney: _vm.closeCollectedMoneyRevenueDialog },
          }),
          _c("InitializeOrderKidsExcelDialog", {
            attrs: {
              listKidCode: _vm.listKidCode,
              listIdOrder: _vm.listIdOrder,
              dataSearch: _vm.dataSearch,
              type: _vm.type,
              isOpenInitializeOrderKidsExcelDialog:
                _vm.isOpenInitializeOrderKidsExcelDialog,
            },
            on: { close: _vm.closeInitializeOrderKidsExcelDialog },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }